"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedUiProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const LocaleContextController_1 = require("../context/locale/localeContextController/LocaleContextController");
const DrawerContextController_1 = require("../context/drawer/drawerContextController/DrawerContextController");
const JobStatusProvider_1 = require("../context/jobStatus/JobStatusProvider");
const Toast_1 = require("../components/toast/Toast");
const AppLocale_enum_1 = require("../context/locale/AppLocale.enum");
const en_json_1 = __importDefault(require("../core/i18n/data/en.json"));
const pl_json_1 = __importDefault(require("../core/i18n/data/pl.json"));
const ThemeProvider_1 = require("./themeProvider/ThemeProvider");
const globalStyle_1 = require("./themeProvider/globalStyle");
const SharedUiProvider = ({ children, translations }) => {
    const mergedTranslations = (0, react_1.useMemo)(() => ({
        [AppLocale_enum_1.AppLocale.en]: { ...translations.en, ...en_json_1.default },
        [AppLocale_enum_1.AppLocale.pl]: { ...translations.pl, ...pl_json_1.default },
    }), [translations, en_json_1.default, pl_json_1.default, AppLocale_enum_1.AppLocale]);
    return ((0, jsx_runtime_1.jsx)(react_1.StrictMode, { children: (0, jsx_runtime_1.jsx)(LocaleContextController_1.LocaleContextController, { translations: mergedTranslations, children: (0, jsx_runtime_1.jsx)(DrawerContextController_1.DrawerContextController, { children: (0, jsx_runtime_1.jsx)(ThemeProvider_1.ThemeProvider, { children: (0, jsx_runtime_1.jsxs)(JobStatusProvider_1.JobStatusProvider, { children: [(0, jsx_runtime_1.jsx)(Toast_1.Toast, {}), (0, jsx_runtime_1.jsx)(material_1.CssBaseline, {}), (0, jsx_runtime_1.jsx)(globalStyle_1.GlobalStyle, {}), (0, jsx_runtime_1.jsx)(material_1.StyledEngineProvider, { injectFirst: true, children: children })] }) }) }) }) }));
};
exports.SharedUiProvider = SharedUiProvider;
